import { useQuery } from "@tanstack/react-query";

import { getAllRedzoneExceptions as getAdminRedzoneExceptions, getRedzoneExceptions } from "services";

import { getEnvironment } from "utils";

import { GET_REDZONE_EXCEPTIONS } from "consts";

import { RedzoneException } from "models";

const env = getEnvironment();

export const useGetRedzoneExceptions = () =>
  useQuery<RedzoneException[]>({
    queryKey: [GET_REDZONE_EXCEPTIONS],
    queryFn: env.admin ? getAdminRedzoneExceptions : getRedzoneExceptions,
  });
